(() => {
  const WHATSAPP_BASE = 'https://wa.me/5571999996767';
  const GENERIC_MESSAGE = 'Olá, vim pela página de locação da InfoStore e gostaria de solicitar uma proposta para minha empresa.';

  const normalizeText = (value, maxLength = 120) => String(value ?? '')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, maxLength);

  const normalizeQuantity = (value) => {
    const normalized = normalizeText(value, 12);
    if (!/^\d+$/.test(normalized)) return '';
    const quantity = Number(normalized);
    return Number.isSafeInteger(quantity) && quantity > 0 ? String(quantity) : '';
  };

  const buildMessage = (data = {}) => {
    const equipment = normalizeText(data.equipment, 80);
    const quantity = normalizeQuantity(data.quantity);
    const period = normalizeText(data.period, 30);
    const duration = normalizeText(data.duration, 60);
    const city = normalizeText(data.city, 80);

    if (!equipment && !quantity && !period && !duration && !city) return GENERIC_MESSAGE;

    const item = equipment || 'equipamentos';
    const need = quantity ? `de aproximadamente ${quantity} ${item}` : `de ${item}`;
    const durationPart = duration ? ` por ${duration}` : '';
    const periodPart = period ? `, no formato ${period}` : '';
    const cityPart = city ? `, para uma operação em ${city}` : '';

    return `Olá, vim pela página de locação da InfoStore. Preciso ${need}${durationPart}${periodPart}${cityPart} e gostaria de receber uma proposta.`;
  };

  const buildUrl = (data = {}) => `${WHATSAPP_BASE}?text=${encodeURIComponent(buildMessage(data))}`;

  window.InfoStoreRentalQuote = {
    buildMessage,
    buildUrl,
    normalizeQuantity,
    normalizeText,
  };

  if (typeof document === 'undefined') return;

  const readForm = (form) => {
    const value = (name) => form.querySelector(`[data-rental-field="${name}"]`)?.value || '';
    return {
      equipment: value('equipment'),
      quantity: value('quantity'),
      period: value('period'),
      duration: value('duration'),
      city: value('city'),
    };
  };

  const init = (root) => {
    const form = root.querySelector('[data-rental-quote-form]');
    if (!form || form.dataset.rentalQuoteReady === 'true') return;
    form.dataset.rentalQuoteReady = 'true';

    const messageInput = form.querySelector('[data-rental-message-input]');
    const preview = form.querySelector('[data-rental-message-preview] p');

    const update = () => {
      const message = buildMessage(readForm(form));
      if (messageInput) messageInput.value = message;
      if (preview) preview.textContent = message;
    };

    form.addEventListener('input', update);
    form.addEventListener('change', update);
    form.addEventListener('submit', update);
    update();
  };

  document.querySelectorAll('[data-rental-section]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.matches?.('[data-rental-section]')
      ? event.target
      : event.target.querySelector?.('[data-rental-section]');
    if (root) init(root);
  });
})();
